import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const TripCtx = createContext(null);
export const useTrip = () => useContext(TripCtx);

export function useLoad(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const reload = useCallback(() => api.get(path).then((r) => { setData(r.data); setError(null); }).catch(setError), [path]);
  useEffect(() => { reload(); }, [reload]);
  return [data, reload, error];
}
